import {
  GetCourseCurriculumUrlProps,
  getCourseCurriculumUrl,
} from '../../utils/get-course-curriculum-url'
import { LectureId } from '../types/lecture-interface'

export const getCourseLectureEmailUrl = ({
  lectureId,
  ...restArgs
}: GetCourseCurriculumUrlProps & { lectureId: LectureId }) =>
  `${getCourseCurriculumUrl(restArgs)}/${lectureId}/email`
